import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';

const WhyItIsImportantModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal header="Why it's important?" isOpen={isOpen} onClose={onClose}>
    <Text>
      This is in the event that your stereo and/or speakers are stolen but not
      the entire car.
    </Text>
  </Modal>
);

export default WhyItIsImportantModal;
